import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { Dayjs } from 'dayjs';
import { TimeZone } from '../../../time/timezone.js';
import { TrueTime } from '../../../time/true-time.js';

export class NFCPassRef extends DataModel {
  static readonly TYPE_ID: string = '87cdd23c75cc4c18932757426dce6dbb';

  private constructor(
    public readonly uniqueId: string,
    public readonly businessRef: BusinessModuleRef,
    public readonly creationDate: Dayjs,
  ) {
    super();
  }

  get $typeId(): string {
    return NFCPassRef.TYPE_ID;
  }

  static create(args: {
      uniqueId: string,
      businessRef: BusinessModuleRef,
  }): NFCPassRef {
    return new NFCPassRef(args.uniqueId, args.businessRef, TrueTime.now());
  }

  static fromMap(context: SerializationContext, map: SerializedData): NFCPassRef {
    return new NFCPassRef(
        MapUtils.get<string>(map, 'uniqueId'),
        BusinessModuleRef.mustDecode(MapUtils.get<string>(map, 'businessRef')),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'businessRef': this.businessRef.encode(),
      'creationDate': context.encodeDate(this.creationDate),
    };
  }

  clone(): this {
    return new NFCPassRef(
        this.uniqueId,
        this.businessRef.clone(),
        TimeZone.cloneDate(this.creationDate),
    ) as this;
  }

  isSame(other: this): boolean {
    if(this === other) {
      return true;
    }

    return this.uniqueId === other.uniqueId &&
        this.businessRef.isSame(other.businessRef) &&
        this.creationDate === other.creationDate;
  }
}

export class NFCPassRefBuilder extends DataModelBuilder<NFCPassRef> {
  build(context: SerializationContext, map: SerializedData): NFCPassRef {
    return NFCPassRef.fromMap(context, map);
  }
}
